import { colors } from '@dixa/lib-shared-tokens';
/** Represents various conversation status attributes. */
export const conversationStatusAttributes = {
    open: { label: 'Open', color: colors.green['500'] },
    closed: { label: 'Closed', color: colors.neutral['500'] },
    pending: { label: 'Follow-up', color: colors.neutral['500'] },
    awaitingpending: { label: 'Follow-up', color: colors.blue['500'] },
};
